import { P, A } from './Typography';

export const BillingText = () => {
  return (
    <P>
      Manage your billing information and subscription below. For questions, contact <b><A href='mailto:support@cloudthread.io'>support@cloudthread.io</A></b>
    </P>
  );
};
